module.exports = __webpack_public_path__ + "img/hzmb-g.52455fcf.png";